import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement>;

export const DiamondAlertIcon = ({ fill = 'currentColor', width = 104, height = 104, ...props }: Props) => {
    return (
        <svg width={width} height={height} viewBox="0 0 104 104" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="51.4961" y="4.12132" width="67" height="67" rx="6.5" transform="rotate(45 51.4961 4.12132)" stroke={fill} strokeWidth="3" />
            <rect x="50" y="34" width="4" height="24" fill={fill} />
            <rect x="50" y="64" width="4" height="4" fill={fill} />
        </svg>
    );
};
